import type { ClientUsageResponse } from "src/services/appSlice";

// Every Ping.Location lookup is priced at a flat 100 credits against the account's total balance.
const CREDITS_PER_LOCATION = 100;

/** Locations the remaining credits pay for: 0 once they run out, `undefined` when the account has no credit balance. */
export const getLocationsRemaining = (usage: ClientUsageResponse): number | undefined =>
  usage.credits ? Math.floor(usage.credits.remaining / CREDITS_PER_LOCATION) : undefined;
